import React from "react";
import {
  ReferencesAndResourcesFormatter,
  Title,
  StyledDialogTitle,
  StyledDialogTitleActions,
  SubTitle,
  ReferencesAndSectionWrapper,
} from "./styled";
import { Dialog } from "@ebscois/react-component-library";
const ReferencesAndResourcesDialog = ({
  showModal,
  setModalVisibility,
  referenceAndResources,
}) => {
  const sections = referenceAndResources?.sections || [];
  return (
    <Dialog
      isOpen={showModal}
      maxWidth="md"
      data-testid="references-and-resources-dialog"
    >
      <ReferencesAndSectionWrapper>
        <StyledDialogTitle data-testid="references-and-resources-dialog-title">
          <StyledDialogTitleActions
            data-testid="references-and-resources-actions"
            onRequestClose={() => setModalVisibility(false)}
            iconSize="md"
          />
        </StyledDialogTitle>
        <Title element="h1" fontFamily="secondary">
          {referenceAndResources?.title}
        </Title>
        {sections.map((section) => renderSection(section))}
      </ReferencesAndSectionWrapper>
    </Dialog>
  );
};

const renderSection = (section) => {
  return (
    <>
      <SubTitle>{section.title}</SubTitle>
      <ReferencesAndResourcesFormatter data-testid={section.testId}>
        {section.data}
      </ReferencesAndResourcesFormatter>
    </>
  );
};

ReferencesAndResourcesDialog.displayName = "ReferencesAndResourcesDialog";
export default ReferencesAndResourcesDialog;
